import {
  ON_ROUTE,
  ON_IS_LOADING,
  ON_PASO_1,
  ON_PASO_1_SUCCESS,
  ON_PASO_2,
  ON_PASO_3,
  ON_PASO_4,
  ADOBE_APP_STARTED,
  ADOBE_APP_ON_CLICK_START,
  ON_IS_EXCEEDED,
  ON_MOCK,
  ON_NOTIFICATION_TOAST
} from "@/config/constants/mutation-types";

describe("Mutation-Types Constants Test", () => {
  it("should have the correct value for ON_ROUTE", () => {
    expect(ON_ROUTE).toEqual("ON_ROUTE");
  });

  it("should have the correct value for ON_IS_LOADING", () => {
    expect(ON_IS_LOADING).toEqual("ON_IS_LOADING");
  });

  it("should have the correct value for ON_PASO_1", () => {
    expect(ON_PASO_1).toEqual("ON_PASO_1");
  });

  it("should have the correct value for ON_PASO_1_SUCCESS", () => {
    expect(ON_PASO_1_SUCCESS).toEqual("ON_PASO_1_SUCCESS");
  });

  it("should have the correct value for ON_PASO_2", () => {
    expect(ON_PASO_2).toEqual("ON_PASO_2");
  });

  it("should have the correct value for ON_PASO_3", () => {
    expect(ON_PASO_3).toEqual("ON_PASO_3");
  });

  it("should have the correct value for ON_PASO_4", () => {
    expect(ON_PASO_4).toEqual("ON_PASO_4");
  });

  it("should have the correct value for ADOBE_APP_STARTED", () => {
    expect(ADOBE_APP_STARTED).toEqual("ADOBE_APP_STARTED");
  });

  it("should have the correct value for ADOBE_APP_ON_CLICK_START", () => {
    expect(ADOBE_APP_ON_CLICK_START).toEqual("ADOBE_APP_ON_CLICK_START");
  });

  it("should have the correct value for ON_IS_EXCEEDED", () => {
    expect(ON_IS_EXCEEDED).toEqual("ON_IS_EXCEEDED");
  });

  it("should have the correct value for ON_MOCK", () => {
    expect(ON_MOCK).toEqual("ON_MOCK");
  });

  it("should have the correct value for ON_NOTIFICATION_TOAST", () => {
    expect(ON_NOTIFICATION_TOAST).toEqual("ON_NOTIFICATION_TOAST");
  });
});
